import styled from 'styled-components'

import { SUMMARY_PANEL_WIDTH_DESKTOP } from '../../constants/constants'

import Heading from '../Heading/Heading'

const TEXT_COLOR = '#1d1d1b'
const MARGIN_BOTTOM_MOBILE = '35px'
const MARGIN_BOTTOM_DESKTOP = '70px'

// TODO: break out panel to shared Styled component
export const SummaryPanel = styled.div<{
  isEditItemPanelActive?: boolean
}>`
  display: ${(props) => (props.isEditItemPanelActive ? 'block' : 'none')};

  @media (min-width: 1200px) {
    height: 100%;
    width: calc(${SUMMARY_PANEL_WIDTH_DESKTOP} + 60px);
    position: relative; // Due to configurator view background effect
    background-color: rgb(249, 249, 249);
    padding-top: 60px;
    padding-right: 45px;
    padding-bottom: 15px;
    overflow-x: hidden;
    overflow-y: auto;
  }
`

const ContentContainer = styled.div`
  padding: 15px 20px 30px;
  display: block;
  box-sizing: border-box;
  position: relative;

  @media (min-width: 1200px) {
    padding: 25px 45px;

    h2 {
      font-size: 26px;
    }
  }

  button:not(.button-primary) {
    background-color: transparent;
  }

  // Create divider effect for some content blocks
  @media (min-width: 768px) {
    button:not(.button-primary) {
      &,
      & + div {
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: calc(-70px / 2);
          left: calc(40% / 2);
          display: block;
          width: 60%;
          height: 1px;
          background: linear-gradient(to right, rgb(0 0 0 / 25%), rgb(0 0 0 / 40%) 20% 80%, rgb(0 0 0 / 25%));
        }
      }
    }
  }
`

export const EmphasizedContent = styled(ContentContainer)`
  background-color: ${(props) => props.theme.palette.background.main};

  .button-primary {
    margin: 0px 0px 30px;
  }
`

export const AdditionalContent = styled(ContentContainer)`
  background-color: transparent;

  h2 {
    margin-top: 10px;
    margin-bottom: 0;
  }

  div:last-of-type {
    h3 {
      margin-bottom: 5px;
    }

    p {
      margin-bottom: 0;

      @media (min-width: 768px) {
        margin-bottom: 15px;
      }
    }
  }

  > div:last-of-type p {
    margin-bottom: 0;
  }
`

export const Text = styled.p`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 15px;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const Email = styled.a`
  display: block;
  color: ${TEXT_COLOR};
  text-decoration: none;
  cursor: pointer;

  p + & {
    margin-top: -15px;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const Link = styled.a`
  display: block;
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: underline;
  cursor: pointer;

  p + & {
    margin-top: -15px;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }

  @media (hover: hover) {
    &:hover {
      font-weight: bold;
    }
  }
`

export const FactBox = styled.div`
  background-color: #ffffff;
  padding: 15px 15px;
  font-family: ${(props) => props.theme.typography.fontFamily};
  margin-bottom: ${MARGIN_BOTTOM_MOBILE};

  @media (min-width: 768px) {
    margin-bottom: ${MARGIN_BOTTOM_DESKTOP};
    padding: 25px 30px;
  }

  h3 {
    margin: 5px 0 15px;
    font-size: 20px;
  }

  p {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 10px;

    b {
      font-weight: 500;
    }

    span {
      font-weight: 400;
      display: inline-flex;
      flex-direction: column;
      align-items: flex-end;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`

export const Cta = styled.button`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  text-align: left;
  border: none;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: ${MARGIN_BOTTOM_MOBILE};

  @media (min-width: 768px) {
    margin-bottom: ${MARGIN_BOTTOM_DESKTOP};
  }

  i:first-of-type {
    margin-right: 10px;
  }

  i:last-of-type {
    position: absolute;
    right: 10px;
  }

  @media (hover: hover) {
    &:not([disabled]):hover {
      color: ${(props) => props.theme.palette.primary.main};

      i {
        color: inherit;
      }
    }
  }
`

export const IncludeItem = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 7px;

  i {
    display: flex;
    flex-shrink: 0;
    font-size: 18px;
    margin-top: 12px;
    margin-right: 10px;
    color: ${(props) => props.theme.palette.primary.main};

    @media (min-width: 768px) {
      font-size: 22px;
      margin-top: 17px;
      margin-right: 15px;
    }
  }

  + h2 {
    margin-top: ${MARGIN_BOTTOM_MOBILE};
  }
`

export const PanelHeader = styled(Heading)`
  font-size: 20px;
  margin-bottom: 15px;

  @media (min-width: 768px) {
    font-size: 32px;
  }
`
